/**
 * Shared DOM helpers for Live Scrubber jump-to-field (CMS errors +
 * contradictions). Keep one copy so visibility rules can't drift.
 */

export const escapeCssAttributeValue = (value: string) =>
  value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

export const isVisibleOasisNavigationTarget = (element: HTMLElement) => {
  if (!element.isConnected) return false;
  if (element.closest('[hidden]')) return false;

  const style = window.getComputedStyle(element);
  return style.display !== 'none' && style.visibility !== 'hidden';
};
